module.exports = __webpack_public_path__ + "static/media/options.df60db16.svg";